import React, { useState, useCallback, useEffect } from "react";
import Delete from "../../assets/img/stm-delete.svg";
import Translations from "../../services/translation.service";
import OfferModal from "../../../src/views/shared/offers.popoup.js";
import Storage from "../../services/storage.service";
import Offers from "../../services/offers.service";
import Spinner from "../shared/card.spinner"
import DeletePopup from "./storefront-delete-popup"
import FirebaseAnalytics from "../../services/firebaseAnalytics"

let prefix = "stm_sum_";
const SummaryOfferSection = ({
  getSummary,
  selectedCard,
  appliedOffer,
  setAppliedOffer,
  setOffersFetchedInitially
}) => {

  const [isOffersModal, setOffersModal] = useState(false);
  const [offersList, setOffersList] = useState({});
  const [unGroupedOffers, setUnGroupedOffers] = useState([]);
  const [activeOffers, setActiveOffers] = useState([]);
  const [modalLoader, setModalLoader] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [isError, setError] = useState(false);
  const [appliedList, setAppliedList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [offersData, setOffersData] = useState([]);
  const [isDeletePopup, setDeletePopup] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const toggleOffersModal = () => {
    setOffersModal((prev) => !prev);
  };

  const toggleDeleteModal = () => {
    setDeletePopup((prev) => !prev);
  };

  const handleAppliedOffers = (key, value) => {
    const updatedAppliedOffer = { ...appliedOffer };
    updatedAppliedOffer[key] = value;
    Storage.set(
      "offer_applied_promotion_id",
      Object.values(updatedAppliedOffer),
      true
    );
    Storage.set(
      "offer_applied_promotion_object",
      updatedAppliedOffer,
      true
    );
    if (setAppliedOffer) {
      setAppliedOffer(updatedAppliedOffer);
    }

  };

  const checkPreActiveOffer = useCallback(
    (offer) => {
      const presSelectedPlan =
        selectedCard || JSON.parse(Storage.get("predefined_selected_plan", true));
      if (presSelectedPlan?.Promotions?.length) {
        return presSelectedPlan?.Promotions.some(
          (item) => item.PromotionCode === offer.PromotionId && !!item.IsMetrics
        );
      } else {
        return false;
      }
    },
    [selectedCard]
  );

  const formattedOffers = useCallback((data) => {
    const offers = {};
    const unGroupedOffers = [];
    const appliedOffer = [];
    const activeOffers = [];
    data.forEach((item) => {
      if (item.IsApplied) {
        appliedOffer.push(item);
      }
      if (checkPreActiveOffer(item)) {
        activeOffers.push(item)
      } else if (item.GroupName && offers[item.GroupName]) {
        offers[item.GroupName].push(item);
      } else if (item.GroupName) {
        offers[item.GroupName] = [item];
      } else {
        unGroupedOffers.push(item);
      }
    });
    return { offers, unGroupedOffers, appliedOffer, activeOffers };
  }, [checkPreActiveOffer]);

  const setPreSelectedOffers = useCallback(
    (list) => {
      const appliedOffer = {};
      list.forEach((item) => {
        if (item.IsApplied) {
          appliedOffer[item.GroupName] = item.PromotionId;
        }
      });
      Storage.set(
        "offer_applied_promotion_id",
        Object.values(appliedOffer),
        true
      );
      Storage.set(
        "offer_applied_promotion_object",
        appliedOffer,
        true
      );
      if (setAppliedOffer) {
        setAppliedOffer(appliedOffer);
      }
    },
    [setAppliedOffer]
  );

  useEffect(() => {
    const { offers, unGroupedOffers, appliedOffer, activeOffers } = formattedOffers(offersData);
    setOffersList(offers || {});
    setUnGroupedOffers(unGroupedOffers || []);
    setAppliedList(appliedOffer || []);
    setActiveOffers(activeOffers);
  }, [offersData, selectedCard, checkPreActiveOffer, formattedOffers]);

  const fetchOffers = useCallback(() => {
    const is5g = JSON.parse(Storage.get("is_category_type_5g", true));
    let API = null;
    if (is5g) {
      API = Offers.get5gAvailableOffers;
    } else {
      API = Offers.getAvailableOffers;
    }
    return API()
      .then((res) => {
        if (res?.data?.Offers) {
          if(setOffersFetchedInitially){
            setOffersFetchedInitially(true)
          }
          setOffersData(res?.data?.Offers);
          setPreSelectedOffers(res?.data?.Offers);
        }
      })
      .catch(() => {
        if(setOffersFetchedInitially){
        setOffersFetchedInitially(true)
        }
      });
  }, [setPreSelectedOffers, setOffersFetchedInitially]);

  useEffect(() => {
    fetchOffers();
  }, [fetchOffers]);

  const handleApply = () => {
    setError(false);
    Storage.clear("promotionErrorStatus");
    let number = JSON.parse(Storage.get("reserved_number_local", true));
    setLoading(true);
    Storage.set("promotionErrorStatus", true, true);
    Offers.checkPromoCode(promoCode, number?.MSISDN || null)
      .then((res) => {
        if (res?.status === 200) {
          Offers.applyPromoCode(promoCode, number?.MSISDN || null)
            .then((res) => {
              fetchOffers();
            })
            .catch((error) => {
            });
        } else {
          Storage.clear("promotionErrorStatus");
          setLoading(false);
        }
      })
      .catch((error) => {
        setError(true);
        Storage.clear("promotionErrorStatus");
        setLoading(false);
      });
  };

  const handleApplyPromoCode = (PromotionId, isApplied, key) => {
    handleAppliedOffers(key, isApplied ? "" : PromotionId);
    Storage.clear("pre-defined-plan-selected")
    setLoading(true);
    if (isApplied) {
      if (Storage.get("latest_offer_code_selected", true) === PromotionId) {
        Storage.clear("latest_offer_code_selected")
      }
      Offers.removeOffer(PromotionId)
        .then((response) => {
          fetchOffers().then(() => {
            getSummary().then(() => {
              setLoading(false);
            })
          }).catch(() => {
            setLoading(false);
          })
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      Storage.set("latest_offer_code_selected", PromotionId, true)
      Storage.set("is_custom_card_selected", false, true)
      let number = JSON.parse(Storage.get("reserved_number_local", true));
      Offers.applyOffer(PromotionId, number?.MSISDN || null)
        .then((response) => {
          fetchOffers().then(() => {
            getSummary().then(() => {
              setLoading(false);
            }).catch(() => {
              setLoading(false);
            })
          }).catch(() => {
            setLoading(false);
          })
        })
        .catch((err) => {
          setModalLoader(false);
        });
    }
  };

  const handleDeleteOffer = () => {
    if (itemToDelete) {
      handleApplyPromoCode(
        itemToDelete.PromotionId,
        itemToDelete.IsApplied,
        itemToDelete.GroupName
      )
    }
    toggleDeleteModal()
  }

  const isOfferError = (data) => {
    const card = selectedCard || JSON.parse(Storage.get("predefined_selected_plan", true))
    return !(card?.Promotions?.some((item) => item.PromotionCode === data.PromotionId) || false) && data.IsApplied
  }

  return (
    <>
      {isOffersModal && (
        <OfferModal
          getSummary={getSummary}
          activeOffers={activeOffers}
          isError={isError}
          unGroupedOffers={unGroupedOffers}
          appliedOffer={appliedOffer}
          offersList={offersList}
          promoCode={promoCode}
          selectedCard={selectedCard}
          setAppliedOffer={setAppliedOffer}
          fetchOffers={fetchOffers}
          setError={setError}
          setPromoCode={setPromoCode}
          handleApply={handleApply}
          modalLoader={modalLoader}
          toggleOffersModal={toggleOffersModal}
        />
      )}
      {isDeletePopup && <DeletePopup
        onClose={toggleDeleteModal}
        onDelete={handleDeleteOffer}
      />}
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="stm-sum-grid-offer">
            {appliedList.map((item) => (
              <React.Fragment key={item.PromotionId}>
                <div className="offer-wrapper">
                  <div className="stm-sum-block stm-sum-block-left">
                    {item?.PromoCode
                      ? Translations.keys[prefix + "Promo_code"] +
                      " (" +
                      item?.PromoCode +
                      ")"
                      : Translations.keys[
                      `applied_offer_title_${item?.PromotionId}`
                      ]}
                  </div>
                  <div className="stm-sum-block-right stm-sum-left-log">
                    <img
                      onClick={() => {
                        toggleDeleteModal()
                        setItemToDelete(item)
                      }
                      }
                      src={Delete}
                      alt=""
                    />
                  </div>
                </div>
                {isOfferError(item) && <p className="card-lower-text-error">
                  {Translations.keys["scr_3810_P_Not_available_with_current_plan_selection"]}
                </p>}
              </React.Fragment>
            ))}
          </div>
        </>
      )}
      <button
        className="stm-sum-extras-btn"
        onClick={() => {
          FirebaseAnalytics.button_clicked(
            Translations.keys[prefix + "choose_offer"]
          )
          toggleOffersModal()
        }}>
        {Translations.keys[prefix + "choose_offer"]}
      </button>
    </>
  );
};

export default SummaryOfferSection;
